<a class="poster-movie" (click)="goMovie($event, movie.id)" href={{movieLink}}>

    <div class="contenedor-imagenes">

        <!-- Cocarda Free-->
        <div class="tarjeta__cocarda" *ngIf="isFree">
            <div class="tarjeta__cocarda-line">
                GRATIS
            </div>
        </div>
        <!-- Cocarda Estreno-->
        <div class="tarjeta__cocarda" *ngIf="esEstreno">
            <div class="tarjeta__cocarda-line line-estreno">
                ESTRENO
            </div>
        </div>
        <!-- Cocarda Sala-->
        <div class="tarjeta__cocarda" *ngIf="esCinema">
            <div class="tarjeta__cocarda-line line-salas">
                EN SALAS
            </div>
        </div>

        <div class="imagen-blur">
            <img width="100%" [src]="fotoPrincipal | ThumbnailImage" alt="{{ movie.title }}">
        </div>

        <div class="imagen">
            <img width="100%" [src]="fotoPrincipal | ThumbnailImage" alt="{{ movie.title }}">
        </div>


    </div>


    <div class="hover" *ngIf="mostrarInfo">
        <div class="fondo"></div>

        <div class="seccion">
            <h3 class="titulo">{{ movie.title }}</h3>
            <h3 class="directores">{{this.selectedDirector?.fullName}} </h3>
            <span class="year">{{ movie.releaseYear }}</span>
        </div>
    </div>
</a>